module.exports = __webpack_public_path__ + "static/media/friends-thumbnail.997380b4.png";